import React from "react";
import { useNavigate } from "react-router-dom";
import TrackPayment from "./TrackPayment";
import { useSelector } from "react-redux";

const Home = ({ campaigns,handlePanelClick }) => {
  //  const navigate = useNavigate();
  const user = useSelector((state) => state.auth?.authData?.user);

  return (
    <>
      <div className="flex flex-wrap gap-4 mt-6">
        <div className="p-4 bg-white border rounded-lg shadow hover:shadow-lg transition duration-300 cursor-pointer"
        onClick={()=>handlePanelClick("Campaigns")}
        >
          <h3 className="text-lg font-semibold mb-2">Total Campaigns</h3>
          <p className="text-2xl font-bold mb-0">{campaigns.length}</p>
        </div>
      </div>
    </>
  );
};

export default Home;
